export interface UsersResponse {
    status: string,
    requestID: string,
    timestamp: string,
    errorMessage: string,
    page: string,
    users: User[],
}

export interface User {
    id: string;
    firstName: string;
    lastName: string;
    customerAddress?: CustomerAddress;
    email: string;
    features: FeatureFlag[];
    phone: string;
    createdAt: string;
    modifiedAt: string;
    settings: CustomerSettings;
    companyID: string;
    storefrontName: string;
    hubspotCustomerID: string;
    stripeCustomerID: string;
    acknowledgements: Acknowledgement[];
    skipMarketingEmails: boolean;
    isInactive: boolean;
}

export interface Acknowledgement {
    name: string;
    date: string;
}

export interface CustomerAddress {
	address1:     string;
	address2:     string;
	city:         string;
	company:      string;
	country:      string;
	province:     string;
	zip:          string;
	provinceCode: string;
	countryCode:  string;
	latitude:     string;
	longitude:    string;
}

export interface CustomerSettings {
    minOrderAmount: number;
    ignoreSuppressions: boolean;
    outputFieldSettings: OutputFieldSetting[];
}

export interface OutputFieldSetting {
    dataSourceID: string;
    outputFields: string[];
}

export enum FeatureFlag {
    ListCounts = "list_counts",
    ListBuilder = "list_builder",
    RadiusSearch = "radius_search",
    VoiceAgent = "ai_agent",
    GoHighLevel = "gohighlevel",
}